module.exports = __webpack_public_path__ + "static/media/financial-skills.c0dbcbb1.png";